/**
 * Created by Johan Schram - KOSMEO ANALITICS - https://kosmeo-a.com on 16/05/2017.
 */

import L from 'leaflet';
import partSrvc from './participants.service';
import './moving-markers.services';
import restSrvc from './rest-service';
import {} from 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled';

import * as d3 from 'd3';
// import {} from 'leaflet.vectorgrid/dist/Leaflet.VectorGrid.bundled.js'



//------------------------------------------------------------------------------------------------------------------
// Leaflet params

L.Icon.Default.imagePath = '.';
// OR
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});




//------------------------------------------------------------------------------------------------------------------
// Variables


var map = null;

var geoJsonLayer = {};
var additionalLayer = {};
var participantsLayer ={};
var waiterLayer ={};
var opacityLayer ={};

var legend = [];

var preventClick = null;
var hasClicked = null;

var legendeList = [];


//------------------------------------------------------------------------------------------------------------------
// Initliasation carte : création carte + fond de carte
function createMap() {

    map = L.map('map').setView([48.857441 , 2.347652], 12);

    var bounds=[
        [48.13 , 1.45],
        [49.25, 3.56]
    ];


    var minZoom=9;

    map.setMaxBounds(bounds);
    map.setMinZoom(minZoom);


    L.tileLayer('https://tile.jawg.io/{z}/{x}/{y}.png?apiKey=b07886adf42a44765fa80067c70dcaecc97290794f175c4975817caa9d166b21', {
        maxZoom: 18, attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OSM</a>, &copy; Tiles courtesy of <a href="https://www.jawg.io/">Jawg</a>'
    }).addTo(map);

    map.setView([48.857441 , 2.347652], 12);
    map.removeControl(map.zoomControl);

    addTransportToMap();
    addMetroToMap();

}

//------------------------------------------------------------------------------------------------------------------
// ajout d'un lister onClick à la carte pour ajouter des participants.
function addClickEventToMapToAddParticipants(onClick){

    function onClickHandler(e){
        if (preventClick !== null){
            return;
        }

        preventClick = defer();
        onClick(e, preventClick);
        var waitForDouble = setTimeout(function(){
            preventClick.resolve(true);
            preventClick = null;
        },500)
    }

    function onDblClickHandler(){
        if (preventClick !== null){
            preventClick.resolve(false);
        }
    }

    map.on('dblclick ', onDblClickHandler);
    map.on('click', onClickHandler);

}

//------------------------------------------------------------------------------------------------------------------
// plot first set of isochrones
async function getAndPlotIsochrones(){

    // Récupération des paramètres.
    var param = partSrvc.participants.getQueryForIsochrone();

    if (!param){
        return ;
    }

    // Appel serveur
    return restSrvc.getIsochronesAuto(encodeForUrl(param, true))
        .then(function(res){
            // appel pour récuperer les isochorne détaillée
            plotGeoJson(res,  "iso1");
            map.removeLayer(opacityLayer);
            return getAndPlotDetailedIsochrones(param, res);
        })
        .catch(function(err){
            map.removeLayer(opacityLayer);
            endWaiter();
            return Promise.reject(err)
        });
}

//------------------------------------------------------------------------------------------------------------------
// plot second set of isochrones
async function getAndPlotDetailedIsochrones(firstQueryParam, firstIsochronesSet){

    var cutoffSecParams = {cutoffSecList : defineTimeParamForDetailedIsochrones(firstIsochronesSet)};
    var queryParam = {...firstQueryParam, ...cutoffSecParams};

    return restSrvc.getIsochronesCustom(encodeForUrl(queryParam, true))
        .then(function(res){

            // appel pour récuperer les isochorne détaillée
            updateLegend(res);
            plotGeoJson(res, "iso2");
            endWaiter();
            return Promise.resolve()
        })
        .catch(function(err){
            // console.log(err);
            return Promise.reject()
        });

}

//------------------------------------------------------------------------------------------------------------------
// clear Isochrones
function clearIsochrones(){
    if(geoJsonLayer['iso1'] && geoJsonLayer['iso1'] !== null) {
        map.removeLayer(geoJsonLayer['iso1']);
    }
    if(geoJsonLayer['iso2'] && geoJsonLayer['iso2'] !== null) {
        map.removeLayer(geoJsonLayer['iso2']);
    }
}

//------------------------------------------------------------------------------------------------------------------
// Plot participant marker
function plotParticipant(id, onDragEnd){

    clearIsochrones();

    var part = partSrvc.participants.getParticipant(id);
    if (part.valid){
        participantsLayer[id] = L.marker(
            L.latLng(
                    part.coord[1], (part.coord[0])
                ),
            {
                id: id,
                draggable: 'true'
            }
        );

        participantsLayer[id].on('dragend', onDragEnd);

        map.addLayer(participantsLayer[id]);

    }
}

//------------------------------------------------------------------------------------------------------------------
// Move participant marker with coordinates
function moveParticipant(id, coord){

    clearIsochrones();

    if (participantsLayer[id]){

        if (coord){
            participantsLayer[id].setLatLng(L.latLng(coord[1], coord[0]))
        }
        else {
            var part = partSrvc.participants.getParticipant(id);
            participantsLayer[id].setLatLng(L.latLng(part.coord[1], part.coord[0]))
        }

    }

}

//------------------------------------------------------------------------------------------------------------------
// Unplot participant marker
function unPlotParticipant(id){

    clearIsochrones();

    if (participantsLayer[id]){
        try{
            map.removeLayer(participantsLayer[id]);
            delete participantsLayer[id];
        }
        catch(err){
            // console.log(err)
        }
    }
}

//------------------------------------------------------------------------------------------------------------------
// Unplot participant marker
function clearAll(){

    clearIsochrones();
    legendeList = [];

    for (var id in participantsLayer){
        try{
            map.removeLayer(participantsLayer[id]);
            delete participantsLayer[id];
        }
        catch(err){
            // console.log(err)
        }
    }

}

//------------------------------------------------------------------------------------------------------------------
// Center map on participants
function centerMapOnParticipants(){
    var bound=[];
    for (var player in participantsLayer){
        bound.push(participantsLayer[player].getLatLng())
    }

    map.fitBounds(bound, {padding : [50, 50] });
}

//------------------------------------------------------------------------------------------------------------------
// Calcul des params temps des isochrones détaillées
function defineTimeParamForDetailedIsochrones(data){

    var cutoffSecList = [];
    var cutoffSecSmallestIsochrone = 99999;

    legendeList = [];

    for (var i = 0; i < data.features.length; i++) {

        try{
            legendeList.push(parseInt(data.features[i].properties.name));
        }
        catch(err){}
        if (parseInt(data.features[i].properties.name) < cutoffSecSmallestIsochrone) {
            cutoffSecSmallestIsochrone = parseInt(data.features[i].properties.name)
        }
    }

    if (data.features.length == 1) {
        cutoffSecList = [cutoffSecSmallestIsochrone - 300, cutoffSecSmallestIsochrone + 300, cutoffSecSmallestIsochrone + 600 ];
    }
    else {
        cutoffSecList = [cutoffSecSmallestIsochrone - 300, cutoffSecSmallestIsochrone + 300];
    }

    return cutoffSecList

}


//------------------------------------------------------------------------------------------------------------------
// met à jour la légende
function updateLegend(data){

    for (var i = 0; i < data.features.length; i++) {
        try{
            legendeList.push(parseInt(data.features[i].properties.name));
        }
        catch(err){}
    }
    for (i = 0 ; i <legendeList.length ; i++){
        legendeList[i] = legendeList[i]/60;
    }

    legendeList.sort(function(a, b) {return a - b;});

    legendeList.push(legendeList[legendeList.length-1]);
}

//------------------------------------------------------------------------------------------------------------------
// Renvoit le tableau de légende
function getLegendeList(data){

    return legendeList;
}

//------------------------------------------------------------------------------------------------------------------
// Plot data from GeoJson (isochrones)
function plotGeoJson(geoJSdata, layerName){

    var getStyle = function(){
        return {
            fillColor: "black",
            weight: 0,
            fillOpacity: 0.3
        };
    };

    return new Promise(function(resolve, reject) {
        try {
            if(geoJsonLayer[layerName] && geoJsonLayer[layerName] !== null) {
                map.removeLayer(geoJsonLayer[layerName]);
            }

            geoJsonLayer[layerName] = L.geoJson(geoJSdata, {
                style: getStyle
            });

            geoJsonLayer[layerName].addTo(map);

            // loaderService.loaderBool.stop();
            resolve();
        }
        catch(err){
            reject(err);
        }
    });




}

// #####################################################################################################################
// ###################################  Waiter #########################################################################
// #####################################################################################################################

function lunchWaiter(){

    // On récupère les points

    var listPoints=[];

    var p = 0;
    for (var player in participantsLayer){
        listPoints.push({
            coord : participantsLayer[player].getLatLng()
        });
        p +=1;
    }

    function getRandomMinIncluMaxExclu(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    function buildItinary(depPoint, pasTemps){
        var temps = 0 ;
        var l0 = depPoint ;
        var l1 = 0 ;
        var chemin = [];
        var tempsChemin = [];
        var pasTemps = 0;
        chemin.push(listPoints[l0].coord);
        while (temps < 40000) {
            l1 = getRandomMinIncluMaxExclu(0, listPoints.length);
            if (l1 === l0){
                l1 = l0 +1 ;
                if (l1>= listPoints.length){
                    l1 = 0;
                }
            }
            chemin.push(listPoints[l1].coord);
            l0 = l1;
            pasTemps = getRandomMinIncluMaxExclu(500, 3000);
            tempsChemin.push(pasTemps);
            temps += pasTemps
        }

        return {chemin : chemin, temps : tempsChemin}
    }


    var myIcon = {
        _1 :L.divIcon({className : 'icocol1'}),
        _2 :L.divIcon({className : 'icocol2'}),
        _3 :L.divIcon({className : 'icocol3'}),
        _4 :L.divIcon({className : 'icocol4'}),
        _5 :L.divIcon({className : 'icocol5'}),
        _6 :L.divIcon({className : 'icocol6'}),
        _0 :L.divIcon({className : 'icocol0'})
    };

    addOpacityLayer();

    for (var i = 0 ; i < listPoints.length; i++){
        var data = buildItinary(i, 2000);
        waiterLayer[i]= L.Marker.movingMarker(data.chemin, data.temps, {icon: myIcon['_'+ ((i%7))]}).addTo(map);
        waiterLayer[i].start();
    }

}

function addOpacityLayer(){
    var latlngs = [[180 , 90],[180, -90],[-180, -90],[-180, 90]];
    opacityLayer = L.polygon(latlngs, {
        color: 'black',
        opacity : 0.8,
        fillColor: 'black',
        fillOpacity: 0.8
    }).addTo(map);
}

function endWaiter(){
    for (var wLayer in  waiterLayer) {
        waiterLayer[wLayer].stop();
        map.removeLayer(waiterLayer[wLayer]);
    }
}

// #####################################################################################################################
// ###################################  additionnal data for map  ###########################################################################
// #####################################################################################################################

function addMetroToMap(){

    var nameIcon = new L.DivIcon({
        className: 'my-div-icon',
        html: '<svg><text>Métro</text></svg>'
    })

    var metroIcon = new L.icon({
        iconUrl: require('../img/metro_s.png'),
        iconSize: [15, 15],
        iconAnchor:[7.5,7.5]
    });
    var rerIcon = new L.icon({
        iconUrl: require('../img/rer_s.png'),
        iconSize: [15, 15],
        iconAnchor:[7.5,7.5]
    });
    var tramIcon = new L.icon({
        iconUrl: require('../img/tram_s.png'),
        iconSize: [15, 15],
        iconAnchor:[7.5,7.5]
    });
    var trainIcon = new  L.icon({
        iconUrl: require('../img/train_s.png'),
        iconSize: [15, 15],
        iconAnchor:[7.5,7.5]
    });

    var getStyleForPointsClassique = function (feature, latlng) {

        // return nameIcon;


        // L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
        return L.marker(latlng, {icon: nameIcon});

        // if (feature.properties.type === 'Metro'){
        //     return L.marker(latlng, {icon: metroIcon});
        // }
        // else if (feature.properties.type === 'RER'){
        //     return L.marker(latlng, {icon: rerIcon});
        // }
        // else if (feature.properties.type === 'Tramway'){
        //     return L.marker(latlng, {icon: tramIcon});
        // }
        // else if (feature.properties.type === 'Train'){
        //     return L.marker(latlng, {icon: trainIcon});
        // }
        // else {
        //     return L.circleMarker(latlng, {
        //         radius: 10,
        //         fillColor: '#4267b2',
        //         color: '#4267b2',
        //         weight: 1,
        //         opacity: 1,
        //         fillOpacity: 1
        //     });
        // }
    };

    var getStyleForPoints = function (properties) {

        if (properties.type === 'Metro'){
            return {icon : metroIcon }
        }
        else if (properties.type === 'RER'){
            // return L.marker(latlng, {icon: rerIcon});
            return {icon : rerIcon }
        }
        else if (properties.type === 'Tramway'){
            // return L.marker(latlng, {icon: tramIcon});
            return {icon : tramIcon }
        }
        else if (properties.type === 'Train'){
            // return L.marker(latlng, {icon: trainIcon});
            return {icon : trainIcon }
        }
        else {
            return {
                icon: new L.Icon.Default()
            };
        }
    };

    var getStyleForPointss = function (properties, zoom) {

        function radiusSize(){

            if (zoom == 18){
                return 7
            }
            if (zoom == 17){
                return 6
            }
            else if (zoom == 16){
                return 5
            }
            else if (zoom == 15){
                if (properties.inter == 1){
                    return 5
                }
                else {
                    return 4
                }
            }
            else if (zoom == 14){
                if (properties.inter == 1){
                    return 4
                }
                else {
                    return 3
                }
            }
            else {
                return 3
            }
        }

        function opacity(){
            if (zoom < 14){
                return 0
            }
            else {
                return 1
            }
        }

        if (properties.inter == 1 ){
            return {
                radius : radiusSize(),
                weight: 1,
                opacity: 1,
                fillOpacity : 1,
                color: "black",
                fillColor : "white",
                fill: true
            };
        }
        else {
            return {
                radius : radiusSize(),
                weight: 1,
                opacity: opacity(),
                fillOpacity : opacity(),
                color: properties.color,
                fillColor : properties.color,
                fill: true
            };
        }

    };

    restSrvc.getMapDataMetro()
        .then(function(data){

            additionalLayer.metroStation =  L.vectorGrid.slicer(data, {
                vectorTileLayerStyles: {
                    sliced : getStyleForPointss
                },
                maxNativeZoom: 18,
                maxZoom: 18,
                minZoom : 12
            });

            additionalLayer.metroStation.addTo(map);
            organizeBaseMapLayers();

        })
}

function addTransportToMap(){

    var getStyleForLines = function (properties, zoom) {

        if (zoom <= 13){
            return {
                weight: 1,
                opacity: 1,
                color: properties.color
            };
        }
        else {
            return {
                weight: 2,
                opacity: 1,
                color: properties.color
            };
        }
    };

    restSrvc.getMapDataTransportLines()
        .then(function(data){

            additionalLayer.transportLines =  L.vectorGrid.slicer(data, {
                vectorTileLayerStyles: {
                    sliced: getStyleForLines
                },
                maxNativeZoom: 18,
                maxZoom: 18,
                minZoom : 12
            });

            additionalLayer.transportLines.addTo(map);
            organizeBaseMapLayers();
        })

}

function organizeBaseMapLayers(){

    try {
        if (map.hasLayer(additionalLayer.metroStation) && map.hasLayer(additionalLayer.transportLines) ){
            additionalLayer.metroStation.bringToFront();
        }
    }
    catch(err){
        // console.log("erreur d'organisation des layer");
        // console.log(err);
    }


}


// #####################################################################################################################
// ###################################  D3JS  ##########################################################################
// #####################################################################################################################


function projectPoint(x, y) {
    var point = map.latLngToLayerPoint(new L.LatLng(y, x));
    this.stream.point(point.x, point.y);
}

function addTransportNameToMap(collection) {

    var svg = d3.select(map.getPanes().overlayPane).append("svg"),
        g = svg.append("g").attr("class", "leaflet-zoom-hide");


    var transform = d3.geoTransform({point: projectPoint});
    var path = d3.geoPath().projection(transform);


    var feature = g.selectAll("path")
        .data(collection.features)
        .enter().append("path")
        .attr("d", path)
        .style("fill", function(d) {
            if (d.properties.inter == 1 ){
                return 'white';
            }
            else {
                return d.properties.color;
            }
        })
        .style("stroke", 'black')
        .style("stroke-width", function(d) {
            if (d.properties.inter == 1 ){
                return 1;
            }
            else {
                return 0;
            }
        })
        .style("stroke-opacity", 0)
        .style("fill-opacity", 0);

    // var icone = g.selectAll("icone")
    //     .data(collection.features)
    //     .enter().append("svg:image")
    //     .attr('y', -12.5 ) // vertical offset
    //     .attr('x', -12.5) // horizontal offset
    //     .attr('width', 25)
    //     .attr('height', 25)
    //     .attr('transform', function(d) {
    //         return 'translate(' + path.centroid(d) + ')';
    //     })
    //     .attr("xlink:href", function(d){
    //         return require('../img/test_void.svg')
    //     });

    var label = g.selectAll(".label")
        .data(collection.features)
        .enter().append("text")
        .attr('transform', function(d) {
            return 'translate(' + path.centroid(d) + ')';
        })
        .attr('dy', function(d){
            return 4;
        }) // vertical offset
        .attr('dx', 15) // horizontal offset
        .text(function(d) {
            return d.properties.lib;
        })
        .attr('class', 'labels')
        .style("font-family", "sans-serif")
        .style("font-size", "12px")
        .style("font-weight", "bold")
        .style("fill", "#2fa5ff")
        .style("stroke", "white")
        .style("stroke-opacity", 0)
        .style("fill-opacity", 0)
        .style("stroke-width", 3)
        .style("paint-order", "stroke");

    map.on("zoomstart", clearStations);
    map.on("zoomend", reset);
    reset();

    function clearStations(){
        label.style("fill-opacity", 0)
            .style("stroke-opacity", 0);

        feature.style("fill-opacity", 0)
            .style("stroke-opacity", 0);
    }

    // Reposition the SVG to cover the features.
    function reset(e) {


        var bounds = path.bounds(collection),
            topLeft = bounds[0],
            bottomRight = bounds[1];

        svg .attr("width", bottomRight[0] - topLeft[0])
            .attr("height", bottomRight[1] - topLeft[1])
            .style("left", topLeft[0] + "px")
            .style("top", topLeft[1] + "px");

        g   .attr("transform", "translate(" + -topLeft[0] + "," + -topLeft[1] + ")");

        feature.attr("d", path);

        label.attr('transform', function(d) {
            return 'translate(' + path.centroid(d) + ')';
        });

        // icone.attr('transform', function(d) {
        //     return 'translate(' + path.centroid(d) + ')';
        // });


        if (e) {

            if (e.target._zoom< 13){
                label.style("fill-opacity", 0)
                    .style("stroke-opacity", 0);

                // icone.attr("xlink:href", function(d){
                //     return require('../img/test_void.svg')
                // });

                feature.style("fill-opacity", 0)
                    .style("stroke-opacity", 0);

            }
            else if (e.target._zoom == 13){

                label.style("fill-opacity", 0)
                    .style("stroke-opacity", 0);

                // icone.attr("xlink:href", function(d){
                //     return require('../img/test_void.svg')
                // });

                feature.style("fill-opacity", function(d){
                        if (d.properties.inter == 1){
                            return 1
                        }
                        else {
                            return 0
                        }
                    })
                    .style("stroke-opacity",function(d){
                        if (d.properties.inter == 1){
                            return 1
                        }
                        else {
                            return 0
                        }
                    });
            }
            else if (e.target._zoom == 14){

                label.style("fill-opacity", 0)
                    .style("stroke-opacity", 0);

                // icone.attr("xlink:href", function(d){
                //     return require('../img/test_void.svg')
                // });

                feature.style("fill-opacity", 1)
                    .style("stroke-opacity", 1);

                label.style("fill-opacity", function(d){
                        if (d.properties.inter == 1){
                            return 1
                        }
                        else {
                            return 0
                        }}
                )
                    .style("stroke-opacity",function(d){
                        if (d.properties.inter == 1){
                            return 0.5
                        }
                        else {
                            return 0
                        }}
                    )
            }
            else {
                label.style("fill-opacity", 1)
                    .style("stroke-opacity", .5);

                feature.style("fill-opacity", 1)
                    .style("stroke-opacity", 1);

                // icone.attr("xlink:href", function(d){
                //
                //         if (d.properties.type === 'Train'){
                //             return require('../img/test_train.svg')
                //         }
                //         else if(d.properties.type === 'RER'){
                //             return require('../img/test_rer.svg')
                //         }
                //         else if(d.properties.type === 'Tramway'){
                //             return require('../img/test_tram.svg')
                //         }
                //         else if(d.properties.type === 'Metro'){
                //             return require('../img/test_metro.svg')
                //         }
                //         else {
                //             return require('../img/test_void.svg')
                //         }
                //     });


            }
        }

    }


}



// #####################################################################################################################
// ###################################  UTIL ###########################################################################
// #####################################################################################################################


//------------------------------------------------------------------------------------------------------------------
//fonction d'encodage de l'URL
function encodeForUrl(data, ignoreNull){

    var stringToEncode = '';
    var temp_string = '';

    var encodeUnderArray = function(array){
        temp_string = '';
        for (var i = 0 ; i < array.length; i++){
            if (temp_string===''){
                if (typeof array[i] !== 'number'){
                    temp_string = encodeURIComponent('"') + encodeURIComponent(array[i]) +  encodeURIComponent('"')
                }
                else {
                    temp_string = encodeURIComponent(array[i])
                }
            }
            else {
                temp_string = temp_string + ',';
                if (typeof array[i] !== 'number'){
                    temp_string = temp_string + encodeURIComponent('"') + encodeURIComponent(array[i]) +  encodeURIComponent('"')
                }
                else {
                    temp_string =  temp_string + encodeURIComponent(array[i])
                }

            }
        }
        return temp_string;
    };

    var EncodeObjectArray = function(array, name){
        temp_string = '';
        for (var i = 0 ; i < array.length; i++){
            if (temp_string===''){
                if (typeof array[i] === 'object'){
                    temp_string = encodeURIComponent(name) + '=[' +  encodeUnderArray(array[i]) + ']';
                }
                else {
                    temp_string = encodeURIComponent(name) + '=' +  encodeURIComponent(array[i]) + '';
                }

            } else {
                if (typeof array[i] === 'object'){
                    temp_string = temp_string + '&' +  encodeURIComponent(name) + '=[' +  encodeUnderArray(array[i]) +']';
                }
                else {
                    temp_string = temp_string + '&' +  encodeURIComponent(name) + '=' +  encodeURIComponent(array[i]) +'';
                }

            }
        }
        return temp_string;
    };

    for(var parameter in data) {

        if (ignoreNull === true){
            if (data[parameter] !== null && data[parameter] !== '' ) {
                if (stringToEncode===''){
                    if (typeof data[parameter] === 'object'){
                        stringToEncode = EncodeObjectArray(data[parameter], parameter)
                    } else {

                        if (parameter=== 'time') {
                            stringToEncode = encodeURIComponent(parameter) + '=' +  data[parameter];
                        }
                        else {
                            stringToEncode = encodeURIComponent(parameter) + '=' +  encodeURIComponent(data[parameter]);
                        }


                    }
                } else {
                    if (typeof data[parameter] === 'object'){
                        stringToEncode = stringToEncode + '&' + EncodeObjectArray(data[parameter], parameter)
                    } else {


                        if (parameter=== 'time') {
                            stringToEncode = stringToEncode + '&' + encodeURIComponent(parameter) + '=' +  data[parameter];
                        }
                        else {
                            stringToEncode = stringToEncode + '&' + encodeURIComponent(parameter) + '=' +  encodeURIComponent(data[parameter]);
                        }
                    }
                }
            }
        } else {
            if (stringToEncode===''){
                if (typeof data[parameter] === 'object'){
                    stringToEncode = EncodeObjectArray(data[parameter], parameter)
                } else {
                    stringToEncode = encodeURIComponent(parameter) + '=' +  encodeURIComponent(data[parameter]);
                }
            } else {
                if (typeof data[parameter] === 'object'){
                    stringToEncode = stringToEncode + '&' + EncodeObjectArray(data[parameter], parameter)
                } else {
                    stringToEncode = stringToEncode + '&' + encodeURIComponent(parameter) + '=' +  encodeURIComponent(data[parameter]);
                }
            }
        }
    }
    return stringToEncode;
}


// #####################################################################################################################
// ###################################  UTIL ###########################################################################
// #####################################################################################################################

function onZoomMetroStation(e){

    // console.log("ZOOMSTART", e.target._zoom);
    //
    // if (e.target._zoom<13){
    //     if (map.hasLayer(additionalLayer.metroStation)){
    //         console.log("removing layer");
    //         map.removeLayer(additionalLayer.metroStation);
    //     }
    // }
    // else {
    //     if (!map.hasLayer(additionalLayer.metroStation && additionalLayer.metroStation)){
    //         console.log("adding layer");
    //         additionalLayer.metroStation.addTo(map);
    //     }
    // }
}

function defer() {
    var res, rej;

    var promise = new Promise((resolve, reject) => {
        res = resolve;
        rej = reject;
    });

    promise.resolve = res;
    promise.reject = rej;

    return promise;
}







export default { createMap, getAndPlotIsochrones, plotParticipant, unPlotParticipant, addClickEventToMapToAddParticipants, moveParticipant, centerMapOnParticipants, lunchWaiter, clearAll, getLegendeList };


// WEBPACK FOOTER //
// ./src/services/leaflet.service.js